import {Component, OnInit} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {filter} from 'rxjs/operators';

import {LoaderService} from './services/loader.service';
import {environment} from 'environments/environment';
import {PottosService} from './services/pottos.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public bgColor = environment.backgroundColor;

  constructor(
    private router: Router,
    private loaderrService: LoaderService,
    private pottosSvc: PottosService,
  ) {
    this.scroll2TopOnNavEnd();
    this.dismissLoaderBeforeNavStart();
    document.body.style.backgroundColor = this.bgColor;
  }

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const currentRoute = this.router.routerState.root.snapshot.firstChild;
        const enablePottosTracking = currentRoute?.data['enablePottosTracking'];

        if (enablePottosTracking) {
          this.pottosSvc.spaInit(event.urlAfterRedirects);
        }
      });
    this.pottosSvc.initializePottos();
  }

  scroll2TopOnNavEnd() {
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      window.scrollTo(0, 0);
    });
  }

  dismissLoaderBeforeNavStart() {
    this.router.events.pipe(filter((e) => e instanceof NavigationStart)).subscribe((e) => {
      this.loaderrService.dismiss();
    });
  }
}
